import Vue from 'vue';

/**
 * Global Definitions
 */
import Poly from './components/index'; 

/**
 * Global Definitions
 * Local Components Which we have control off.
 */

 /** --------- */
Vue.component("icon",                Poly.Icons.FontAwesomeIcon);

/** --------- */
Vue.component("p-header",            Poly.Elements.primaryHeader);
Vue.component("s-header",            Poly.Elements.secondaryHeader);
Vue.component("radio-list",          Poly.Elements.radioList);
Vue.component("section-header",            Poly.Elements.sectionHeader);
Vue.component("page-header",               Poly.Elements.pageHeader);
Vue.component("info-header",               Poly.Elements.infoHeader);

/** --------- */
Vue.component("page-header-btn",            Poly.Elements.pageHeaderBtn); 
Vue.component("action-button",            Poly.Elements.actionButton);

/** --------- */
Vue.component("accordion",            Poly.Controls.Accordion);

/** --------- */
Vue.component("modal",            Poly.Elements.modal);

/** --------- */
Vue.component("Medicine",            Poly.Layouts.Medicine);
Vue.component("MedicineAtoZList",    Poly.Layouts.MedicineAtoZList);
Vue.component("MedicineByLetter",    Poly.Layouts.MedicineByLetter);
Vue.component("MyMedicineList",      Poly.Layouts.MyMedicineList);
Vue.component("MyReview",            Poly.Layouts.MyReview);

export default {};
